import React from 'react'
import Link from '../components/Link'
import BlogHeader from '../components/BlogHeader'

const BlogPage = () => {
  return (
    <div>
      <div className="container">
        <div
          className="blog"
          style={{ margin: '0 auto', maxWidth: '70ch', marginBottom: '5em' }}
        >
          <Link href="/blog/31-march">&#8592; Previous</Link>
          <h2>Daily Debts</h2>
          <span className="author">by Jon Shulver, 14 April 2020</span>
          <p style={{ fontStyle: 'italic' }}>
            “And forgive us our debts, as we also have forgiven our debtors.”
          </p>
          <p>
            I’m sure there are many things that we think we need right now. Many
            things the world needs. If we were to write down the needs, the list
            would be long. But as Jesus teaches his followers to pray to their
            Heavenly Father, the daily requests are few, and included is a
            request for forgiveness.
          </p>
          <p>
            I suspect that forgiveness isn’t something that many people feel
            they need each day. Some days – yes. But every day? That seems
            excessive. Maybe we feel like that too. After all, haven’t we just
            celebrated Jesus’ death and resurrection, which offers us complete
            forgiveness for all eternity? Why the need to daily seek God’s
            forgiveness?
          </p>
          <p>
            It’s wonderfully true that Jesus’ death and resurrection have paid
            the price for our sins. The debt that stood against us has been
            paid. The forgiving, atoning, redeeming work of Jesus was finished
            on the cross. We have joined God’s family – forever. But, for now,
            our daily relationship with our Father is still affected by our
            sins. We want to live as children of God – but often we don’t. We
            therefore seek his forgiveness when will fall short of living out
            our true identity.
          </p>
          <p>
            As the pastor Trevin Wax says “The prayer reminds us of our identity
            – people called and chosen by God to execute His forgiveness into
            everyday life. We should be breathing in and out forgiveness like
            air!” Which is why Jesus links our forgiveness with our willingness
            to forgive others. The way we have been treated impacts the way we
            treat others. “If we think we’ve accepted forgiveness from God but
            have refused that forgiveness to others, we have deceived ourselves.
            Failure to forgive communicates… I haven’t been forgiven.”
          </p>
          <p>
            Spending lots of time in a confined space with members of our
            households, having time to dwell on things said and done to us,
            feeling anxious: these experiences might all adversely impact our
            willingness to forgive others. Letting go of a debt isn’t easy. But
            that’s what forgiven people are called to do. It’s who we are. It’s
            what we do. We forgive our debtors.
          </p>
          <p>
            Today, let’s ask our Heavenly Father to forgive our debts, our sins.
            And let’s be ready to forgive others. Not tomorrow – but today.
          </p>
        </div>
      </div>
    </div>
  )
}

export default BlogPage



// WEBPACK FOOTER //
// ./src/pages/blog.js